module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iNDgwIiB2aWV3Qm94PSIwIDAgMzAgMTgiPjxwYXRoIGZpbGw9IiNkYTFhMzUiIGQ9Ik0wIDBoMzB2MThIMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAwbDIwLjgyNSAxOEgzMEw5LjE3NSAweiIvPjxwYXRoIGQ9Ik0xLjUzIDBsMjAuODI0IDE4aDYuMTE3TDcuNjQ2IDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/tto.svg
// module id = E1Dm
// module chunks = 0